module.exports = __webpack_public_path__ + "img/album21_36.3b4135a0.jpg";